import { forwardRef, type Ref, type SVGProps } from "react";
const IconRevealFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M18.9 15.1a3 3 0 0 1 .1.9 3 3 0 1 1-3-3 3 3 0 0 1 .9.1 1.5 1.5 0 0 0-.9 1.4 1.5 1.5 0 0 0 1.5 1.5 1.5 1.5 0 0 0 1.4-.9"
    />
    <path
      fill="currentColor"
      d="M29.5 14.7c-12.5-15-23.4-4.3-27 0a2 2 0 0 0 0 2.6c12.5 15 23.4 4.3 27 0a2 2 0 0 0 0-2.6M16 22a6 6 0 1 1 6-6 6 6 0 0 1-6 6"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRevealFilledSVG);
ForwardRef.displayName = "IconRevealFilled";
export { ForwardRef as IconRevealFilled };
